import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { HypotensionInputData } from "./HypotensionInputData";
import { HypotensionResults } from './HypotensionResults';

/**
 * # HypotensionPatients
 * 
 * HypotensionPatients을 설명하세요.
 */
export const HypotensionPatients = types
  .model('HypotensionPatients')
  // --------------------------------------------------------------------------
  .props({
    id: types.optional(types.number, 0), // 환자 ID
    input_data: types.optional(types.array(HypotensionInputData), []),
    results: types.optional(types.array(HypotensionResults), []),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model hypotensionPatients --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IHypotensionPatients;
      (Object.keys(newProps) as THypotensionPatientsKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type THypotensionPatients = Instance<typeof HypotensionPatients>;
type THypotensionPatientsSnapshot = SnapshotOut<typeof HypotensionPatients>

export interface IHypotensionPatients extends THypotensionPatients {}
export type THypotensionPatientsKeys = keyof THypotensionPatientsSnapshot & string;
export interface IHypotensionPatientsSnapshot extends THypotensionPatientsSnapshot {}
export const createHypotensionPatients = () => 
  types.optional(HypotensionPatients, {} as THypotensionPatients);